export const actions = {
  PRODUCTOS_EN_CAJA_LOAD_REQUESTED: 'PRODUCTOS_EN_CAJA_LOAD_REQUESTED',
  PRODUCTOS_EN_CAJA_LOAD_SUCCEDED: 'PRODUCTOS_EN_CAJA_LOAD_SUCCEDED',
  PRODUCTOS_EN_CAJA_LOAD_FAILED: 'PRODUCTOS_EN_CAJA_LOAD_FAILED',
}

export const getProductosEnCajaLoadAction = (dispatch, filter) => {
  dispatch({
    type: actions.PRODUCTOS_EN_CAJA_LOAD_REQUESTED,
    payload: filter,
  })
}
